import React from 'react';

// WhatsApp CTA button for reservations
// Usage: <WhatsAppCTA />
const WhatsAppCTA = () => (
  <a
    href="https://wa.me/34648728151"
    target="_blank"
    rel="noopener noreferrer"
    className="whatsapp-cta"
    aria-label="Reservar camper por WhatsApp"
  >
    <span role="img" aria-label="WhatsApp" style={{marginRight: 8}}>💬</span>
    ¡Reserva por WhatsApp!
  </a>
);

export default WhatsAppCTA; 